import IS_BROWSER from '../isBrowser/index.js';
import Logger from '../services/logger/index.js';

var getDeviceId = function getDeviceId(withConsole) {
  try {
    var _localStorage;
    return IS_BROWSER && ((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem('paa_did')) || '';
  } catch (e) {
    Logger.error(e, withConsole);
  }
};

export { getDeviceId as default };
//# sourceMappingURL=index.js.map
